import {
  Box,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Slide,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { CarouselContainer, SlideWrapper } from '../StyledComponents';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import ProgramFilter from '../../../../../components/filters/ProgramFilter';
import { useLazyGetApiClinsQuery } from '../../../../../app/athenaApiGen';

const Clins = () => {
  const [params, setParams] = useState({
    page: 1,
    pageSize: 2,
    programId: '',
  });

  const [slideDirection, setSlideDirection] = useState('up');
  const [queryClins, { data, isLoading }] = useLazyGetApiClinsQuery();

  const fetchClins = useCallback(async () => {
    try {
      await queryClins({
        page: params.page,
        pageSize: params.pageSize,
        programId: params.programId,
      }).unwrap();
    } catch (err) {
      console.log(err);
    }
  }, [params, queryClins]);

  useEffect(() => {
    fetchClins();
  }, [fetchClins]);

  const handleProgramIdFilter = (newId) => {
    setParams((prev) => ({
      ...prev,
      page: 1,
      programId: newId ? newId : '',
    }));
  };

  return (
    <React.Fragment>
      {isLoading && data?.items.length > 0 ? (
        <Box>Loading....</Box>
      ) : (
        <Box
          sx={{ display: 'flex', flexDirection: 'column', padding: '8px 0px' }}
        >
          <ProgramFilter
            programId={params.programId}
            handleChange={handleProgramIdFilter}
          />
          <CarouselContainer>
            <IconButton
              sx={{ mr: 2 }}
              disabled={data?.page === 1}
              onClick={() => {
                setSlideDirection('right');
                setParams((prev) => ({ ...prev, page: prev.page - 1 }));
              }}
            >
              <ArrowBack />
            </IconButton>
            <SlideWrapper>
              {data?.items.map((item) => (
                <Box
                  key={item.clinId}
                  sx={{
                    width: '100%',
                    height: '100%',
                    display: 'block',
                  }}
                >
                  <Slide direction={slideDirection} in={true}>
                    <Stack
                      direction="row"
                      sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}
                    >
                      <Card sx={{ borderColor: '#0092CB' }}>
                        <CardHeader
                          title={item.clinCode}
                          subheader={item.clinTitle}
                          sx={{ paddingBottom: 2 }}
                        />
                        <CardContent>
                          <Typography sx={{ color: '#0092CB' }} fontSize={24}>
                            ${item.funded}
                          </Typography>
                          <Typography>Budget</Typography>
                          <Typography sx={{ color: '#0092CB' }} fontSize={24}>
                            ${item.projectAllocated}
                          </Typography>
                          <Typography>Allocated</Typography>
                          <Typography sx={{ color: '#0092CB' }} fontSize={24}>
                            ${item.projectAllocationRemaining}
                          </Typography>
                          <Typography>Remaining Budget</Typography>
                        </CardContent>
                      </Card>
                    </Stack>
                  </Slide>
                </Box>
              ))}
            </SlideWrapper>
            <IconButton
              sx={{ ml: 2 }}
              disabled={data?.page === Math.ceil(data?.total / data?.pageSize)}
              onClick={() => {
                setSlideDirection('left');
                setParams((prev) => ({ ...prev, page: prev.page + 1 }));
              }}
            >
              <ArrowForward />
            </IconButton>
          </CarouselContainer>
        </Box>
      )}
    </React.Fragment>
  );
};

export default Clins;
